var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCamera2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1.2 0a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.7 3.4a1.6 1.6 0 0 0-1.4.823L6.207 6.194a.4.4 0 0 1-.35.206H3A1.6 1.6 0 0 0 1.4 8v10A1.6 1.6 0 0 0 3 19.6h18a1.6 1.6 0 0 0 1.6-1.6V8A1.6 1.6 0 0 0 21 6.4h-2.856a.4.4 0 0 1-.35-.206L16.7 4.223A1.6 1.6 0 0 0 15.3 3.4zm-.35 1.406A.4.4 0 0 1 8.7 4.6h6.6a.4.4 0 0 1 .35.206l1.095 1.97a1.6 1.6 0 0 0 1.399.824H21c.22 0 .4.179.4.4v10a.4.4 0 0 1-.4.4H3a.4.4 0 0 1-.4-.4V8c0-.221.18-.4.4-.4h2.856a1.6 1.6 0 0 0 1.399-.823z",
  clipRule: "evenodd"
})));
export { SvgIconCamera2 as ReactComponent };